/* src/app/home/trailer-request/request-grid-row.component.scss */
.hidden {
  visibility: hidden;
}
.request-links {
  display: flex;
  flex-direction: row-reverse;
  font-size: 12px;
}
.request-links a {
  text-decoration: underline;
}
.request-links a:not(:first-child)::after {
  content: "|";
  margin: 0px 4px 0px 4px;
  color: black;
}
.comments-indicator {
  height: 28px;
  width: 28px;
  background-color: #F88C00;
  border-radius: 50%;
  text-align: center;
  position: absolute;
  top: -14px;
  right: 15px;
  z-index: 11;
}
.comments-indicator.icon::after {
  font-family: upsicons, fantasy !important;
  content: "\e62f" !important;
  color: #000000;
  font-size: 20px;
}
.trailer-requests {
  padding-right: 0px;
}
.trailer-request {
  width: 344px;
  padding: 15px 0px 15px 0px;
  border-top: 1px solid #979797;
  margin-right: 0px;
  display: grid;
  grid-template-areas: "menu" "info" "progress" "trailers";
}
.section-menu {
  grid-area: menu;
  position: relative;
  margin-bottom: 25px;
}
.section-info {
  grid-area: info;
}
.section-progress {
  grid-area: progress;
  padding-top: 17px;
  display: flex;
  justify-content: center;
}
.section-trailers {
  grid-area: trailers;
}
.attention-needed {
  border-left: 8px solid #F68B20;
}
.driver-created-request {
  color: #F68B20;
  font-style: italic;
  white-space: nowrap;
  display: none;
}
.driver-created-request::after {
  content: "|";
  margin: 0px 4px 0px 4px;
  color: black;
  font-style: normal;
}
.driver-created-request-sm {
  display: block;
  color: #F68B20;
  font-style: italic;
  white-space: nowrap;
  text-align: right;
  margin-right: 25px;
}
@media (min-width: 740px) {
  .request-links {
    font-size: 14px;
    padding-right: 15px;
  }
  .trailer-request {
    width: 100%;
    padding-right: 12px;
    padding-left: 12px;
  }
  .section-trailers {
    display: flex;
    justify-content: center;
  }
  .section-progress {
    justify-content: center;
  }
}
@media (min-width: 1280px) {
  .request-links {
    padding-right: 10px;
  }
  .comments-indicator {
    right: -5px;
  }
  .driver-created-request-sm {
    display: none;
  }
  .driver-created-request {
    display: inline;
  }
  .trailer-request {
    padding: 15px 0px 15px 15px !important;
    grid-template-columns: 1fr auto;
    grid-template-areas: "info menu" "info progress" "info trailers";
  }
  .trailer-request > * {
    padding-left: 12px;
    padding-right: 12px;
  }
  .section-progress {
    margin-bottom: 20px;
  }
  .section-progress request-rejection {
    justify-self: center;
  }
  .section-trailers {
    justify-content: flex-end;
  }
}
@media (min-width: 1625px) {
  .trailer-request {
    padding: 15px 0px 15px 15px;
    grid-template-columns: 300px minmax(392px, 1fr) 482px;
    grid-template-rows: auto 1fr;
    grid-template-areas: "info progress menu" "info progress trailers";
  }
  .section-menu {
    margin-bottom: 0px;
  }
  .section-progress {
    justify-content: center;
    align-self: center;
    margin-bottom: 0px;
    padding-top: 0px;
  }
  .section-progress request-rejection {
    justify-self: center;
  }
  .section-trailers {
    justify-content: flex-end;
  }
}
@media (min-width: 1880px) {
  .request-links {
    padding-right: 20px;
  }
  .comments-indicator {
    right: -5px;
  }
  .driver-created-request {
    display: inline;
  }
  .trailer-request {
    padding: 15px 0px 15px 15px;
    grid-template-columns: 300px minmax(392px, 1fr) 482px;
    grid-template-rows: auto 1fr;
    grid-template-areas: "info progress menu" "info progress trailers";
  }
  .section-menu {
    margin-bottom: 0px;
  }
  .section-progress {
    justify-content: center;
    align-self: center;
    margin-bottom: 0px;
    padding-top: 0px;
  }
  .section-progress request-rejection {
    justify-self: center;
  }
  .section-trailers {
    justify-content: flex-end;
  }
}
/*# sourceMappingURL=request-grid-row.component.css.map */
